import { AdvisorMode } from "@omni/types/components/aiden/advisorMode.enum";
import { AdvisorType } from "@omni/types/components/aiden/advisorType.enum";
import { Button } from "@omni/ui/components/Button/button.component";
import { PropsWithChildren } from "react";

import { useCallToActionContext } from "@/components/General/CallToAction/callToAction.context";

type AdvisorButtonProps = PropsWithChildren<{
    advisorId: string;
    advisorType: AdvisorType;
    advisorMode: AdvisorMode;
}>;

const AdvisorButton = ({
    advisorId,
    advisorType,
    advisorMode,
    children
}: AdvisorButtonProps) => {
    const { trackingProperties, styleProperties } = useCallToActionContext();

    return (
        <Button
            {...styleProperties.button}
            type="button"
            dataAttributes={{
                ...trackingProperties.click,
                ...(advisorType === AdvisorType.ProductCheck && {
                    "data-product-check": ""
                }),
                "data-advisor-id": advisorId,
                "data-aiden-mode":
                    advisorMode === AdvisorMode.Classic
                        ? "sidebar"
                        : "ai-sidebar"
            }}
            stopPropagation={false}
        >
            {children}
        </Button>
    );
};

export { AdvisorButton };
